export const ChatsRoute = {
  Chat: 'chat',
  ChatArchive: 'chat-archive',
  NewChatOnPost: 'new-chat-on-post',
  NewChatOnComment: 'new-chat-on-comment',
  NewChatOnGroup: 'new-chat-on-group'
} as const;

export type ChatsRoute = (typeof ChatsRoute)[keyof typeof ChatsRoute];

export type ChatsParam = {
  [ChatsRoute.Chat]: { id: string; personName?: string };
  [ChatsRoute.ChatArchive]: undefined;
  [ChatsRoute.NewChatOnPost]: { postId: string };
  [ChatsRoute.NewChatOnComment]: { commentId: string };
  [ChatsRoute.NewChatOnGroup]: { groupId: string; memberId: string };
};
